import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AffiliateReferralsPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/facilitate/wallet?tab=affiliate', { replace: true });
  }, [navigate]);

  return (
    <div style={{ minHeight: '100vh', background: '#071414', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
      <p style={{ color: 'rgba(255,255,255,0.6)', fontStyle: 'italic' }}>Redirecting to Unified Financial Wallet...</p>
    </div>
  );
};

export default AffiliateReferralsPage;